/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { PaginationMetaDto } from './pagination-meta-dto';
import { StationDto } from './station-dto';
 /**
 *
 *
 * @export
 * @interface StationPaginatedResponseDto
 */
export interface StationPaginatedResponseDto {

    /**
     * @type {Array<StationDto>}
     * @memberof StationPaginatedResponseDto
     */
    data: Array<StationDto>;

    /**
     * @type {PaginationMetaDto}
     * @memberof StationPaginatedResponseDto
     */
    meta: PaginationMetaDto;
}
